import useGetPaymentProviderStatusQuery from '@/api/queries/useGetPaymentProviderStatusQuery';
import Breadcrumbs from '@/components/Breadcrumbs';
import BreadcrumbsTargetContext from '@/components/BreadcrumbsTargetContext';
import { Settings as BaseSettings } from '@/modules/settings/pages/Settings';
import breadcrumbs from '@/modules/supplier/pages/Settings/breadcrumbs';
import { getSupplierSettingsSections } from '@/modules/supplier/pages/Settings/sections';
import { Outlet } from 'react-router-dom';

const Settings = () => {
  const { status: paymentStatus, isLoading } = useGetPaymentProviderStatusQuery();

  return (
    <>
      <div className="settings-print-hidden">
        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </div>
      {!isLoading && (
        <BaseSettings sections={getSupplierSettingsSections(paymentStatus?.available)}>
          <BreadcrumbsTargetContext.Provider value={null}>
            <Outlet />
          </BreadcrumbsTargetContext.Provider>
        </BaseSettings>
      )}
    </>
  );
};

export default Settings;
